<script setup lang="ts">
    import FlagCheck from '@Assets/images/idv/flag_check.svg';
    import useCompanyImageBaseUrl from '@Use/useCompanyImageBaseUrl';
    import { useCompanyStore } from '@Stores/company.store';
    import { useLocationStore } from '@Stores/location.store';
    import { FlowLayout } from '@Shared';

    const companyStore = useCompanyStore();
    const locationStore = useLocationStore();
    const companyImageBaseUrl = useCompanyImageBaseUrl();
</script>

<template>
    <flow-layout
        suppress-back-to-dashboard
        :company="companyStore.company"
        :brand="companyStore.brand"
        :location="locationStore.location"
        :company-image-base-url="companyImageBaseUrl">
            <div class="complete-view">
                <div class="complete-view__content">
                    <app-form-content-layout>
                        <img
                            alt="A flag with the word 'End', and a checkmark"
                            class="complete-graphic"
                            :src="FlagCheck" />
                        <h2>
                            Verification Submitted
                        </h2>

                        <p>
                            Thank you for submitting your ID and photo!
                        </p>
                        <p>
                            You may now close this tab.
                        </p>
                    </app-form-content-layout>

                </div>
            </div>
    </flow-layout>
</template>

<style lang="scss" scoped>
@use 'certifid-v2-client-hub-styles' as *;
.complete-view {
    display: flex;
    flex-flow: column nowrap;
    align-items: center;

    &__content {
        text-align: center;

        display: flex;
        justify-content: center;
        align-items: center;
        padding: 2rem;
    }

    .complete-graphic {
        width: 5.75rem;
        height: 6.125rem;
        align-self: center;
    }

}
</style>
